import { gql } from '../__generated__';

export default gql(`
  fragment AddressItem on Address {
    id
    address1
    address2
    city
    postalCode
    country
  }
`);

export let GET_COUNTRIES = gql(`
  query GetCountries {
    countries: allCountries {
      mostUsed
      all
    }
  }
`);
